import { BlankButton } from "./blank-button";

type Props = {
	onRemoveLocationTag: () => void;
	tagListChildren: React.ReactNode;
	freeWordTagChildren: React.ReactNode;
};
export const SelectedTagListSection = ({ onRemoveLocationTag, tagListChildren, freeWordTagChildren }: Props) => {
	return (
		<div className="border-b">
			<div className="flex flex-wrap items-center gap-x-3 gap-y-1">
				<p>選択中のタグ一覧（最大3つまで）</p>

				<BlankButton onClickCallback={onRemoveLocationTag} />
			</div>

			<div className="grid gap-2 p-2">
				{/* 選択中のタグ一覧 */}
				{tagListChildren}

				{/* フリーワードでのタグの選択 */}
				{freeWordTagChildren}
			</div>
		</div>
	);
};
